<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col-sm-12 d-flex flex-wrap justify-content-center">

        <div v-for="(row, index) in items" :key="index" class="card m-2 shadow-sm w-full"
          style="max-width: 80vh;">
          <div class="card-body d-flex flex-column justify-content-between">
            <div class="flex-column">
              <div class="card-badge">
                <span class="badge badge-success">
                  {{ row.status }}
                </span>
              </div>

              <div class="text-secondary">
                <i class="icon md-calendar-note" aria-hidden="true"></i>
                <span>{{ row.date_start }} - {{ row.date_end }}</span>
              </div>
            </div>

            <h5 class="mb-auto">
              <span>{{ index + 1 }}. {{ row.name }}</span>
            </h5>

            <section class="mt-2 mb-4">
              <span>Прогресс по курсу:</span>
              <div class="d-flex align-items-center">
                <progress class="w-full" max="100" :value="row.progress_slides"></progress>
                <span style="width: 3rem" class="ml-1">{{row.progress_slides}}%</span>
              </div>

              <span v-if="row.has_test">Тестирование:</span>
              <div class="d-flex align-items-center" v-if="row.has_test">
                <progress class="w-full" max="100" :value="row.progress_tests"></progress>
                <span style="width: 3rem" class="ml-1">{{row.progress_tests}}%</span>
              </div>
            </section>

            <div class="d-flex row justify-content-around">
              <a class="btn btn-primary mt-1"
                 :href="row.button_course_status ? row.course_url : ''"
                 :disabled="!row.button_course_status">
                <b>{{ row.button_course_text }}</b>
              </a>
              <a class="btn btn-primary mt-1"
                 :href="row.button_exam_status && !row.practice_block && !row.remote_practice_block ? row.exam_url : ''"
                 :disabled="!row.button_exam_status"
                 @click="examLinkHandler(row, $event)">
                <b>{{ row.button_exam_text }}</b>
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Практика не отмечена менеджером — к экзамену не пускаем -->
    <practice-required-modal v-if="showPracticeModal"
                             :practice-sheet-url="practiceSheetUrl"
                             @close="showPracticeModal = false" />

    <!-- Дистанционная практика -->
    <remote-practice-modal v-if="showRemotePracticeModal"
                           :sheet-url="remotePractice.sheetUrl"
                           :sign-url="remotePractice.signUrl"
                           :upload-url="remotePractice.uploadUrl"
                           :pep-allowed="remotePractice.pepAllowed"
                           @passed="onRemotePracticePassed"
                           @close="showRemotePracticeModal = false" />
  </div>
</template>

<script>
import PracticeRequiredModal from "./PracticeRequiredModal.vue";
import RemotePracticeModal from "./RemotePracticeModal.vue";

export default {
  components: {
    PracticeRequiredModal,
    RemotePracticeModal
  },
  props: {
    /** @type {EducationsData[]} */
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showPracticeModal: false,
      practiceSheetUrl: '',
      practiceAutoShown: false,
      remotePracticeAutoShown: false,
      showRemotePracticeModal: false,
      remotePractice: { sheetUrl: '', signUrl: '', uploadUrl: '', pepAllowed: false, examUrl: '' }
    };
  },
  watch: {
    // Пришли редиректом с /exam — сразу объясняем, почему экзамен не открылся
    items(rows) {
      this.autoShowPracticeModal(rows);
      this.autoShowRemotePracticeModal(rows);
    }
  },
  methods: {
    autoShowRemotePracticeModal(rows) {
      if (this.remotePracticeAutoShown) return;
      if (!/[?&]remote_practice_required=1/.test(window.location.search)) return;

      const row = rows.find((r) => r.remote_practice_block);
      if (!row) return;

      this.openRemotePracticeModal(row);
      this.remotePracticeAutoShown = true;
    },
    openRemotePracticeModal(row) {
      this.remotePractice = {
        sheetUrl: row.remote_practice_sheet_url || '',
        signUrl: row.remote_practice_sign_url || '',
        uploadUrl: row.remote_practice_upload_url || '',
        pepAllowed: !!row.practice_pep_allowed,
        examUrl: row.exam_url || ''
      };
      this.showRemotePracticeModal = true;
    },
    onRemotePracticePassed() {
      this.showRemotePracticeModal = false;

      if (this.remotePractice.examUrl) {
        window.location.href = this.remotePractice.examUrl;
      } else {
        window.location.reload();
      }
    },
    autoShowPracticeModal(rows) {
      if (this.practiceAutoShown) return;
      if (!/[?&]practice_required=1/.test(window.location.search)) return;

      const row = rows.find((r) => r.practice_block);
      if (!row) return;

      this.practiceSheetUrl = row.practice_sheet_url || '';
      this.showPracticeModal = true;
      this.practiceAutoShown = true;
    },
    adaptDate(date) {
      const d = new Date(date);
      return d.toLocaleDateString();
    },
    examLinkHandler(row, event) {
      // Практика обязательна, но менеджер не отметил её прохождение — к экзамену не пускаем
      if (row.button_exam_status && row.practice_block) {
        event.preventDefault();
        this.practiceSheetUrl = row.practice_sheet_url || '';
        this.showPracticeModal = true;
        return;
      }

      if (row.button_exam_status && row.remote_practice_block) {
        event.preventDefault();
        this.openRemotePracticeModal(row);
      }
    }
  }
};
</script>

<style scoped>
.container {
  margin: 25px auto;
}

.card {
  max-width: 80vh;
}

.card-body {
  padding: 1.25rem;
}

.card-top {
  display: flex;
  justify-content: space-between;
}

.badge-success {
  background-color: #28a745;
  color: white;
}

.progress {
  width: 100%;
  background-color: #e0e0e0;
  border-radius: 0.215rem;
}

.progress-bar-tests {
  background-color: #51b53f;
  transition: width .6s ease;
}

.ml-auto {
  margin-left: auto !important;
}

.card-date {
  color: #7d756c;
}

.btn-primary {
  background-color: #f86c01;
  border: none;
  color: white;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
}
</style>
